import React, { useState } from 'react';
import CommonModal from '../../Components/CommonModal';
import { request_evidence_exception, bulk_request_exception } from '../../services';

function RaiseExceptionModal(props) {
    const { evidenceTimelineId, evidenceTimelineIds = [], isDWI = false, onHide, onSuccess } = props;
    const [resMsg, setResMsg] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        user_justification: "",
        user_attachment: null,
    });

    // Get list of IDs to process (support both single and bulk)
    const getIds = () => {
        if (evidenceTimelineIds.length > 0) return evidenceTimelineIds;
        if (evidenceTimelineId) return [evidenceTimelineId];
        return [];
    };

    // Validation function
    const validate = () => {
        const newErrors = {};

        if (!formData.user_justification || formData.user_justification.trim() === "") {
            newErrors.user_justification = "User justification is required.";
        } else if (formData.user_justification.trim().length < 1) {
            newErrors.user_justification = "User justification must be at least 1 character.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // Handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({ ...prev, user_attachment: file }));
            setErrors((prev) => ({ ...prev, user_attachment: "" }));
        }
    };


    // Submit handler
    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!validate()) return;
        setLoading(true);
        setResMsg("");

        const ids = getIds();

        // DWI: use bulk API in a single request
        if (isDWI) {
            const formDataToSend = new FormData();
            formDataToSend.append("evidence_timeline", ids[0]);
            formDataToSend.append("user_justification", formData.user_justification);
            formDataToSend.append("evidence_timeline_ids", JSON.stringify(ids));
            if (formData.user_attachment) {
                formDataToSend.append("user_attachment", formData.user_attachment);
            }
            try {
                const response = await bulk_request_exception(formDataToSend);
                const errorMessage = response?.statusCode?.error?.message;
                if (errorMessage) {
                    setResMsg(errorMessage);
                } else {
                    onHide && onHide();
                    onSuccess && onSuccess();
                }
            } catch (err) {
                setResMsg(err?.response?.data?.error?.message || err?.message || "Failed to raise exception");
            }
            setLoading(false);
            return;
        }

        // Non-DWI: loop through individual requests
        let allSuccess = true;
        let lastError = "";

        for (const id of ids) {
            const formDataToSend = new FormData();
            formDataToSend.append("evidence_timeline_id", id);
            formDataToSend.append("user_justification", formData.user_justification);

            if (formData.user_attachment) {
                formDataToSend.append("user_attachment", formData.user_attachment);
            }

            try {
                const response = await request_evidence_exception(formDataToSend);
                const errorMessage = response?.statusCode?.error?.message;
                const responseData = response?.statusCode?.response_data;

                if (errorMessage) {
                    allSuccess = false;
                    lastError = errorMessage;
                } else if (!responseData?.message) {
                    allSuccess = false;
                    lastError = errorMessage || "Failed to raise exception";
                }
            } catch (err) {
                allSuccess = false;
                lastError = err?.response?.data?.message || err?.message || "Failed to raise exception";
            }
        }

        setLoading(false);

        if (allSuccess) {
            onHide && onHide();
            onSuccess && onSuccess();
        } else {
            setResMsg(lastError || "Some exceptions failed to raise");
        }
    };

    const idCount = getIds().length;

    return (
        <CommonModal
            show={props?.show}
            onHide={onHide}
            title={`Raise Exception${idCount > 1 ? ` (${idCount} selected)` : ''}`}
            buttons={[{
                text: idCount > 1 ? `Raise ${idCount} Exceptions` : 'Raise Exception',
                variant: 'primary',
                onClick: handleSubmit,
                loading,
                loadingText: 'Submitting…',
                disabled: loading,
            }]}
        >
            <div className="cmn-modal-field">
                <label className="cmn-modal-label">User Justification<span className="cmn-modal-req">*</span></label>
                <textarea
                    name="user_justification"
                    placeholder="Enter your justification for raising this exception"
                    value={formData.user_justification}
                    onChange={handleInputChange}
                    rows={5}
                    className="cmn-modal-input cmn-modal-textarea"
                />
                {errors.user_justification && <p className="cmn-modal-field-err">{errors.user_justification}</p>}
            </div>

            <div className="cmn-modal-field mt-3">
                <label className="cmn-modal-label">User Attachment</label>
                {/* Native input rather than CommonInput: CommonInput does not
                    forward `accept`, and dropping it would stop the picker
                    filtering to the allowed document/image types. It still
                    carries CommonModal's own input styling. */}
                <input
                    type="file"
                    name="user_attachment"
                    onChange={handleFileChange}
                    className="cmn-modal-input"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                />
                {formData.user_attachment && (
                    <p className="cmn-modal-subtitle mb-0">Selected: {formData.user_attachment.name}</p>
                )}
                {errors.user_attachment && <p className="cmn-modal-field-err">{errors.user_attachment}</p>}
            </div>

            {resMsg && <p className="cmn-modal-error">{resMsg}</p>}
        </CommonModal>
    );
}

export default RaiseExceptionModal;